<template>
  <div>
    <main-layout>
      <div class="pa-4">
        <v-tabs class="mb-4">
          <v-tab v-if="!isAgent" :to="{ name: 'ttb-dashboard-nonvoice-overview' }">Overview</v-tab>
          <v-tab :to="{ name: 'ttb-dashboard-nonvoice-agents' }">Agents</v-tab>
          <v-tab :to="{ name: 'ttb-dashboard-nonvoice-reply-comment' }">Reply Comment</v-tab>
          <v-tab :to="{ name: 'ttb-dashboard-nonvoice-survey' }">Survey</v-tab>
          <v-tab v-if="!isAgent" :to="{ name: 'ttb-dashboard-nonvoice-report' }">Report</v-tab>
        </v-tabs>

        <router-view />
      </div>
    </main-layout>
  </div>
</template>

<script>
export default {
  computed: {
    isAgent() {
      return this.$store.state.privilege && this.$store.state.privilege.role === 'agent'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/index.vue